module.exports = __webpack_public_path__ + "img/dg.92bcbf23.png";